import { Button } from '@lifebit-ai/lds'
import styled from 'styled-components'

export { ItemIcon, ItemInfo, ItemRow, ItemSubtitle, ItemTitle } from '../FileDetails/FileDetails.styles'

export const RowActionButton = styled(Button)`
  &:hover {
    background: ${({ theme }) => theme.color.background.highlight};
  }

  svg {
    width: ${({ theme }) => theme.size.icon.small};
    height: ${({ theme }) => theme.size.icon.small};

    path {
      fill: ${({ theme }) => theme.color.content.main};
    }
  }
`
